<template>
    <div id="latest-news">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="section-title">LATEST NEWS</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 latest-news-left mb-3">
                    <div>
                        <h2>{{ title }}</h2>
                        <p>{{ strip_html(excerpt) }}</p>
                        <a :href="slug">Read more ></a>
                    </div>
                </div>
                <div class="col-md-6 latest-news-r order-first order-md-2 mb-3">
                    <img width="100%" :src="'/storage/' + img" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            body: "",
            slug: "",
            img: ""
        };
    },

    created() {
        this.fetchStories();
    },

    methods: {
        strip_html(value) {
            var div = document.createElement("div");
            div.innerHTML = value;
            var text = div.textContent || div.innerText || "";
            return text;
        },
        fetchStories() {
            fetch("/api/v1/stories/latest")
                .then(res => res.json())
                .then(res => {
                    this.title = res.title;
                    this.img = res.img;
                    this.body = res.body;
                    this.excerpt = res.excerpt;
                    this.slug = "/stories/" + res.slug;
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped>
#latest-news .section-title {
    font-family: WWF, "Nunito", sans-serif;
    margin-bottom: 1rem !important;
    font-size: 3rem;
}

#latest-news {
    padding-top: 5rem;
    padding-bottom: 3rem;
    background-color: #f9f9f9;
    min-width: 100%;
}
#latest-news .section-title {
    font-family: WWF, "Nunito", sans-serif;
    margin-bottom: 1rem;
    font-size: 3rem;
}
#latest-news .latest-news-left {
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    /* display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical; */
}

#latest-news .latest-news-left div {
    background-color: #f07d00;
    color: white;
    padding: 50px 0px;
    height: 100%;
}

#latest-news .latest-news-left a {
    color: black;
}

#latest-news .latest-news-left p,
h2,
a {
    padding-right: 40px;
    padding-left: 40px;
}

#latest-news .latest-news-left p {
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

@media only screen and (max-width: 768px) {
    .stories .row {
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
}
</style>
